module.exports = ".btn-actions {\n  border: none;\n  overflow: hidden; }\n\n.btn-addEmpresa {\n  width: 250px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administracion/empresas/empresas.component.scss
// module id = ./src/app/administracion/empresas/empresas.component.scss
// module chunks = main